import React, { useState, useEffect } from "react";

const DmeFolioStatusFilters = ({ onSearch, current, availableChains = [] }) => {
    const [filters, setFilters] = useState({
        chain: "",
        from: "",
        to: "",
    });

    useEffect(() => {
        setFilters({
            chain: current?.chain || "",
            from: current?.from || "",
            to: current?.to || "",
        });
    }, [current]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearch(filters);
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="bg-white p-4 rounded-xl shadow mb-4 flex flex-wrap items-end gap-4"
        >
            <div className="flex flex-col">
                <label className="text-sm text-gray-500">Cadena</label>
                <select
                    name="chain"
                    value={filters.chain}
                    onChange={handleChange}
                    className="border rounded px-2 py-1 min-w-[180px]"
                >
                    <option value="">-- Todas las cadenas --</option>
                    {availableChains.map((c) => (
                        <option key={c} value={c}>
                            {c}
                        </option>
                    ))}
                </select>
            </div>

            <div className="flex flex-col">
                <label className="text-sm text-gray-500">Desde</label>
                <input
                    type="date"
                    name="from"
                    value={filters.from}
                    onChange={handleChange}
                    className="border rounded px-2 py-1"
                />
            </div>

            <div className="flex flex-col">
                <label className="text-sm text-gray-500">Hasta</label>
                <input
                    type="date"
                    name="to"
                    value={filters.to}
                    onChange={handleChange}
                    className="border rounded px-2 py-1"
                />
            </div>

            <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
                Consultar
            </button>
        </form>
    );
};

export default DmeFolioStatusFilters;